import { render, staticRenderFns } from "./FichaAmeaca.vue?vue&type=template&id=7f839ca0&"
import script from "./FichaAmeaca.vue?vue&type=script&lang=js&"
export * from "./FichaAmeaca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports